export enum FieldName {
  Number = 'cardNumber',
  ExpireDate = 'cardExpiration',
  CVV = 'cardCvv',
  HolderName = 'cardHolderName',
  PostalCode = 'cardZipCode',
}

export type TCardFieldName = 'cardNumber' | 'cardExpiration' | 'cardCvv' | 'cardHolderName' | 'cardZipCode';
